import React, { useEffect, useCallback, useMemo } from 'react';
import pt from 'prop-types';
import { Button } from 'antd';
import { Field } from 'redux-form';
import get from 'lodash/get';

import { adminServiceCentersColumns } from 'utils/tablesConfig';
import validators from 'utils/redux-form/validators';
import { Page, ReduxModalForm, ReduxInputs, Table } from 'components/shared';

import './ServiceCenters.scss';

const ServiceCenters = (props) => {
    const { actions, serviceCenters, filteredServiceCenters } = props;
    const { fetchServiceCenters, toggleEditModal, submitEdit, edit } = actions;
    const { loading, modals } = serviceCenters;

    useEffect(() => {
        fetchServiceCenters();
    }, []);

    const getEditFormIntialValues = useCallback((modalPayload) => {
        if (modalPayload.new) {
            return {
                name: '',
                phone: '',
            };
        }
        return {
            name: modalPayload.name,
            phone: modalPayload.phone,
        };
    }, []);

    const openCreateModal = useCallback(() => {
        edit({ new: true });
    }, []);

    const newModalOpen = useMemo(() => !!get(modals, 'editServiceCenter.data.new'), [modals]);

    return (
        <Page className="service-centers-admin wide-table">
            <ReduxModalForm
                formId="adminServiceCentersEdit"
                title={newModalOpen ? 'Створення сервісного центру' : 'Редагування сервісного центру'}
                submitButtonText={newModalOpen ? 'Створити' : 'Редагувати'}
                optionsPath="adminServiceCenters.modals.editServiceCenter"
                getIntialValues={getEditFormIntialValues}
                toggler={toggleEditModal}
                onSubmit={submitEdit}
            >
                <Field
                    name="name"
                    component={ReduxInputs.Text}
                    id="service_center_name"
                    label="Назва"
                    validate={[validators.required]}
                />
                <Field
                    name="phone"
                    component={ReduxInputs.Text}
                    id="service_center_phone"
                    label="Телефон"
                    validate={[validators.required]}
                />
            </ReduxModalForm>

            <div className="container">
                <Button onClick={openCreateModal} style={{ marginBottom: '20px' }}>Додати сервісний центр</Button>
            </div>

            <Table
                rowKey="id"
                rowClassName={record => record.className}
                data={filteredServiceCenters}
                loading={loading}
                paginationPath={false}
                columns={adminServiceCentersColumns}
            />
        </Page>
    );
};

ServiceCenters.propTypes = {
    actions: pt.shape({}).isRequired,
    // adminAutomatons: pt.shape({}).isRequired,
    // filteredAdminAutomatons: pt.arrayOf(transaction),
};

ServiceCenters.defaultProps = {
    // filteredAdminAutomatons: [],
};

export default ServiceCenters;
